import React, {Component} from 'react';
import ReactModal from 'react-modal';
import config from "../config";
import { calculateStars } from '../utils/Utils'
import StarRatingComponent from 'react-star-rating-component';

class ReferentDetail extends Component {

    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: false
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    openModal() {
        this.setState({modalIsOpen: true});
    }

    closeModal() {
        this.setState({modalIsOpen: false});
    }

    render() {
        let {referent} = this.props
        return <li key={referent.id+Math.random()*5} className={'list-group-item'}>
            <div className={'row'}>
                <div className={'col-md-8'}>
                    <div className={'row'}>
                        <div className={'col-md-8'}>
                            <span onClick={this.openModal} style={{lineHeight: '34px', display: 'inline-block', paddingRight: '20px', cursor: 'pointer'}}>{referent.anrede} {referent.vorname} {referent.nachname}</span>
                            {isNaN(calculateStars(referent.bewertungen, this.props.thema.id).gesamt) ?
                                <span>
                                   <StarRatingComponent name="Keine Bewertungen hinterlegt"
                                                        editing={false}
                                                        renderStarIcon={() => <i className={"far fa-star"} />}
                                                        starCount={4}
                                                        value={0}
                                   />
                                </span>
                                :
                                <span>
                                    <StarRatingComponent name="Bewertung"
                                                         editing={false}
                                                         renderStarIcon={() => <i className={"fas fa-star"} />}
                                                         starCount={4}
                                                         value={calculateStars(referent.bewertungen, this.props.thema.id).gesamt}
                                    />
                                    ({calculateStars(referent.bewertungen, this.props.thema.id).countGesamt})
                                </span>
                            }

                        </div>
                    </div>
                </div>
                <div className={'col-md-4'}>
                    <div style={{textAlign: 'right'}}>
                        {referent.email && <a title={'Email senden'} href={'mailto:'+referent.email} className={'btn btn-default'}><i className={"far fa-address-card"}/></a> }
                        <span title={'Details anzeigen'} onClick={this.openModal} className={'btn btn-default'}><i className={'fas fa-info-circle'}/></span>
                    </div>
                    <div className={'clearfix'}/>
                </div>
            </div>
            <ReactModal isOpen={this.state.modalIsOpen} onRequestClose={this.closeModal} contentLabel="Example Modal" appElement={document.getElementById('biwe-referenten')}>
                <div className={'row'}>
                    <div className={'col-xs-2'}>
                        <div className={'detailBbvLogo'}>
                            <img src={config.baseBbvUrl + '/themes/custom/bbv/logo.svg'} alt={'Logo'}/>
                        </div>
                    </div>
                    <div className={'col-xs-10'}>
                        <button onClick={this.closeModal} type="button" className="close" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    </div>
                </div>
                <hr/>
                <h1>{referent.anrede} {referent.vorname} {referent.nachname}</h1>
                <hr />
                <div className={'row'}>
                    <div className={'col-sm-12 col-md-8'}>
                        { referent.einsatzgebiet && <div><strong>Einsatzgebiet:</strong> {referent.einsatzgebiet}</div> }
                        { referent.referenzen && <div><strong>Referenzen:</strong> {referent.referenzen}</div> }
                        { referent.qualifikation && <div><strong>Qualifikation:</strong> {referent.qualifikation}</div> }
                        <hr />
                        <h3>Bewertungen zum Thema:</h3>
                        <p><strong>{this.props.thema.name}</strong></p>
                        <p>{this.props.thema.ziel}</p>
                        <div>
                            <strong>Vortrag: </strong>
                            {isNaN(calculateStars(referent.bewertungen, this.props.thema.id).vortrag) ?
                                <span>
                                   <StarRatingComponent name="Keine Bewertungen hinterlegt"
                                                        editing={false}
                                                        renderStarIcon={() => <i className={"far fa-star"} />}
                                                        starCount={4}
                                                        value={0}
                                   />
                                </span>
                                :
                                <span>
                                    <StarRatingComponent name="Bewertung"
                                                         editing={false}
                                                         renderStarIcon={() => <i className={"fas fa-star"} />}
                                                         starCount={4}
                                                         value={calculateStars(referent.bewertungen, this.props.thema.id).vortrag}
                                    />
                                    ({calculateStars(referent.bewertungen, this.props.thema.id).countVortrag})
                                </span>
                            }
                        </div>
                        <div>
                            <strong>Inhalt: </strong>
                            {isNaN(calculateStars(referent.bewertungen, this.props.thema.id).inhalt) ?
                                <span>
                                   <StarRatingComponent name="Keine Bewertungen hinterlegt"
                                                        editing={false}
                                                        renderStarIcon={() => <i className={"far fa-star"} />}
                                                        starCount={4}
                                                        value={0}
                                   />
                                </span>
                                :
                                <span>
                                    <StarRatingComponent name="Bewertung"
                                                         editing={false}
                                                         renderStarIcon={() => <i className={"fas fa-star"} />}
                                                         starCount={4}
                                                         value={calculateStars(referent.bewertungen, this.props.thema.id).inhalt}
                                    />
                                    ({calculateStars(referent.bewertungen, this.props.thema.id).countInhalt})
                                </span>
                            }
                        </div>
                        <div>
                            <strong>Referent: </strong>
                            {isNaN(calculateStars(referent.bewertungen, this.props.thema.id).referent) ?
                                <span>
                                   <StarRatingComponent name="Keine Bewertungen hinterlegt"
                                                        editing={false}
                                                        renderStarIcon={() => <i className={"far fa-star"} />}
                                                        starCount={4}
                                                        value={0}
                                   />
                                </span>
                                :
                                <span>
                                    <StarRatingComponent name="Bewertung"
                                                         editing={false}
                                                         renderStarIcon={() => <i className={"fas fa-star"} />}
                                                         starCount={4}
                                                         value={calculateStars(referent.bewertungen, this.props.thema.id).referent}
                                    />
                                    ({calculateStars(referent.bewertungen, this.props.thema.id).countReferent})
                                </span>
                            }
                        </div>
                        <hr />
                        <h3>Weitere Themen dieses Referenten:</h3>
                        <ul className={'list-group referenten'}>
                        { referent.themen.map(
                            thema =>
                                <li key={thema.id+Math.random()*5} className={'list-group-item'}>
                                    <div className={'row'}>
                                        <div className={'col-md-8'}>
                                            {thema.name}
                                        </div>
                                        <div className={'col-md-4'}>
                                            <div style={{textAlign:'right'}}>
                                                {isNaN(calculateStars(referent.bewertungen, thema.id).gesamt) ?
                                                    <span>
                                                       <StarRatingComponent name="Keine Bewertungen hinterlegt"
                                                                            editing={false}
                                                                            renderStarIcon={() => <i className={"far fa-star"} />}
                                                                            starCount={4}
                                                                            value={0}
                                                       />
                                                    </span>
                                                                :
                                                                <span>
                                                        <StarRatingComponent name="Bewertung"
                                                                             editing={false}
                                                                             renderStarIcon={() => <i className={"fas fa-star"} />}
                                                                             starCount={4}
                                                                             value={calculateStars(referent.bewertungen, thema.id).gesamt}
                                                        />
                                                        ({calculateStars(referent.bewertungen, thema.id).countGesamt})
                                                    </span>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'row'}>
                                        <div className={'col-md-12'}>
                                            <small>{thema.ziel}</small>
                                        </div>
                                    </div>
                                </li>
                        )}
                        </ul>
                    </div>
                    <div className={'col-sm-12 col-md-4'}>
                        <div className={'block-dark'}>
                            <div className={'tab-content'}>
                                <div className={'vsp-2'} />
                                <div>
                                    <div><strong>Wohnort:</strong></div>
                                    { referent.ort && <div>Ort: {referent.ort}</div> }
                                    { referent.kreis && <div>Landkreis: {referent.kreis}</div> }
                                    { referent.regierungsbezirk && <div>Regierungsbezirk: {referent.regierungsbezirk}</div> }
                                    { referent.bundesland && <div>Bundesland: {referent.bundesland}</div> }
                                </div>
                                <hr />
                                <div>
                                    <div><strong>Referent kontaktieren:</strong></div>
                                    { referent.email && <div><strong>E-Mail:</strong> <a href={'mailgo:'+referent.email}>{referent.email}</a></div> }
                                    { referent.internet && <div><strong>Website:</strong> <a target={'blank'} href={referent.internet}>{referent.internet}</a></div> }
                                </div>
                                <hr />
                                <div>
                                    <div><strong>Kreisverband:</strong></div>
                                    <div>{referent.kreisverband.art} {referent.kreisverband.dienststelle}</div>
                                    { referent.kreisverband.telefon && <div>Tel.: {referent.kreisverband.telefon}</div> }
                                    { referent.kreisverband.fax && <div>Fax: {referent.kreisverband.fax}</div> }
                                    { referent.kreisverband.mail && <div><a href={'mailto:'+referent.kreisverband.mail}>{referent.kreisverband.mail}</a></div> }
                                </div>
                                <div className={'vsp-2'} />
                            </div>
                        </div>
                    </div>
                </div>
            </ReactModal>
        </li>
    }
}

export default ReferentDetail




// WEBPACK FOOTER //
// ./src/components/ReferentDetail.js